/* Установщик «Коллаж»: объект в window на том месте порядка скриптов, где стоял assets/bot-collage.js.
   В серверном режиме движок шаблона получает сервер экрана (collage-server.ts) и экран collage встаёт в реестр движков студии;
   выбирает его только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createCollage } from './engine';
import { createCollageServer, registerCollageEngine } from './collage-server';

export function installCollage() {
  const server = isServerMode();
  createCollage(server ? createCollageServer : null);
  if (server) registerCollageEngine();
}
